import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as accountMembershipEffects from './account-membership.effects';
import { accountMembershipFeature } from './account-membership.reducer';
import * as inviteEffects from './invite.effects';
import * as redeemInviteEffects from './redeem-invite.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(accountMembershipFeature),
    EffectsModule.forFeature([accountMembershipEffects, inviteEffects, redeemInviteEffects]),
  ],
})
export class AccountMembershipStateModule {}
